import { IconButton } from "@mui/material";

export function CloseButton({ ariaLabel, onClick }: { ariaLabel: string; onClick: () => void }) {
  return (
    <IconButton className="records-icon-button" type="button" aria-label={ariaLabel} title="Close" onClick={onClick}>
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
      </svg>
    </IconButton>
  );
}
